
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import DecorationCave from "../../decorations/jungle/DecorationCave";
import BoundsMarker from "../../editor/BoundsMarker";
import FinishMarker from "../../editor/FinishMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleEndChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // DecorationCave
    const decorationCave = new DecorationCave(scene, 644, 429);
    this.add(decorationCave);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 1089, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // finishMarker
    const finishMarker = new FinishMarker(scene, 490, 669);
    this.add(finishMarker);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -73, 853);
    this.add(trunk_png_2);

    // decorationTrunk
    const decorationTrunk = new DecorationTrunk(scene, 362, 947);
    this.add(decorationTrunk);

    // platformMarkerFoliage3
    const platformMarkerFoliage3 = new PlatformMarkerFoliage3(scene, -78, 541);
    this.add(platformMarkerFoliage3);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 245, 516);
    this.add(gemMarker_11);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 34, 471);
    this.add(megaGemMarker_2);

    // smashableMarkerVine
    const smashableMarkerVine = new SmashableMarkerVine(scene, -61, 353);
    this.add(smashableMarkerVine);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, -45, 205);
    this.add(platformFoliage1);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage4(scene, 376, 631);
    this.add(platformMarkerFoliage);

    // this (components)
    new ChunkBoundaries(this);

    // smashableMarkerVine (components)
    const smashableMarkerVineSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine);
    smashableMarkerVineSimpleBreakableBlocker.allowedCharacter = "panda";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
